<template>
  <section
    v-if="seasons.length > 0"
    class="SeasonListView"
    data-testid="seasonList"
    aria-label="Carousel of current seasons"
    role="region"
    :aria-busy="isFetching"
  >
    <h2
      class="SeasonListView__title"
      data-testid="seasonListTitle"
    >
      <template v-if="seasons.length > 1">
        Current seasons
      </template>
      <template v-else>
        Current season
      </template>
    </h2>
    <div
      class="SeasonListView__list"
      role="group"
      aria-label="List of seasons"
    >
      <SeasonListItemView
        v-for="season in seasons"
        :key="season.id"
        v-bind="{ season }"
        :data-season-id="season.id"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { SeasonForHome } from "@/stores/useSeasonStore";
import { ref } from "vue";
import SeasonListItemView from "./SeasonListItemView.vue";

const {
  seasons,
} = defineProps<{
  seasons: Array<SeasonForHome>,
}>();

const isFetching = ref(false);
</script>

<style lang="scss" scoped>
.SeasonListView {
  display: grid;
  gap: 16px;
  align-items: start;
  width: 100%;
  padding: 24px 0;
}

.SeasonListView__title {
  padding: var(--fontSafariOffset) 16px 0;
  overflow: hidden;

  color: var(--themeColorNeutral600);

  font-size: 14px;
  font-weight: var(--fontWeightMedium);
  text-transform: uppercase;
}

.SeasonListView__list {
  display: grid;
  gap: 16px;
  padding: 0 16px;
}
</style>
